import { styled } from '@mui/material';

export const DashboardWrapper = styled('div')(({ theme }) => ({
  backgroundColor : '#F9F9F9',
}));
